
<script>
import New from './New6'
import Edit from '../Edit'
export default {
  mixins: [New, Edit]
}
</script>
